import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';

export const FETCH_AGENTS_REQUEST = 'FETCH_AGENTS_REQUEST';
export const FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS';
export const FETCH_AGENTS_ERROR = 'FETCH_AGENTS_ERROR';

export const FETCH_AGENT_OPTIONS_REQUEST = 'FETCH_AGENT_OPTIONS_REQUEST';
export const FETCH_AGENT_OPTIONS_SUCCESS = 'FETCH_AGENT_OPTIONS_SUCCESS';
export const FETCH_AGENT_OPTIONS_ERROR = 'FETCH_AGENT_OPTIONS_ERROR';

export const FETCH_AGENT_GROUP_OPTIONS_REQUEST = 'FETCH_AGENT_GROUP_OPTIONS_REQUEST';
export const FETCH_AGENT_GROUP_OPTIONS_SUCCESS = 'FETCH_AGENT_GROUP_OPTIONS_SUCCESS';
export const FETCH_AGENT_GROUP_OPTIONS_ERROR = 'FETCH_AGENT_GROUP_OPTIONS_ERROR';

export const GET_AGENT_HIERARCHY_DATA_REQUEST =
  'GET_AGENT_HIERARCHY_DATA_REQUEST';
export const GET_AGENT_HIERARCHY_DATA_SUCCESS =
  'GET_AGENT_HIERARCHY_DATA_SUCCESS';
export const GET_AGENT_HIERARCHY_DATA_ERROR = 'GET_AGENT_HIERARCHY_DATA_ERROR';

export const GET_AGENT_DETAIL_REQUEST = 'GET_AGENT_DETAIL_REQUEST';
export const GET_AGENT_DETAIL_SUCCESS = 'GET_AGENT_DETAIL_SUCCESS';
export const GET_AGENT_DETAIL_ERROR = 'GET_AGENT_DETAIL_ERROR';

export const UPDATE_AGENT_REQUEST = 'UPDATE_AGENT_REQUEST';
export const UPDATE_AGENT_SUCCESS = 'UPDATE_AGENT_SUCCESS';
export const UPDATE_AGENT_ERROR = 'UPDATE_AGENT_ERROR';

export const DELETE_AGENT_REQUEST = 'DELETE_AGENT_REQUEST';
export const DELETE_AGENT_SUCCESS = 'DELETE_AGENT_SUCCESS';
export const DELETE_AGENT_ERROR = 'DELETE_AGENT_ERROR';

export const DELETE_AGENT_GROUP_REQUEST = 'DELETE_AGENT_GROUP_REQUEST';
export const DELETE_AGENT_GROUP_SUCCESS = 'DELETE_AGENT_GROUP_SUCCESS';
export const DELETE_AGENT_GROUP_ERROR = 'DELETE_AGENT_GROUP_ERROR';

export const CREATE_AGENT_LEVEL_REQUEST = 'CREATE_AGENT_LEVEL_REQUEST';
export const CREATE_AGENT_LEVEL_SUCCESS = 'CREATE_AGENT_LEVEL_SUCCESS';
export const CREATE_AGENT_LEVEL_ERROR = 'CREATE_AGENT_LEVEL_ERROR';

export const GET_AGENT_LEVEL_DETAIL_REQUEST = 'GET_AGENT_LEVEL_DETAIL_REQUEST';
export const GET_AGENT_LEVEL_DETAIL_SUCCESS = 'GET_AGENT_LEVEL_DETAIL_SUCCESS';
export const GET_AGENT_LEVEL_DETAIL_ERROR = 'GET_AGENT_LEVEL_DETAIL_ERROR';


export const DELETE_AGENT_LEVEL_REQUEST = 'DELETE_AGENT_LEVEL_REQUEST';
export const DELETE_AGENT_LEVEL_SUCCESS = 'DELETE_AGENT_LEVEL_SUCCESS';
export const DELETE_AGENT_LEVEL_ERROR = 'DELETE_AGENT_LEVEL_ERROR';

export const FETCH_AGENT_LEVEL_REQUEST = 'FETCH_AGENT_LEVEL_REQUEST';
export const FETCH_AGENT_LEVEL_SUCCESS = 'FETCH_AGENT_LEVEL_SUCCESS';
export const FETCH_AGENT_LEVEL_ERROR = 'FETCH_AGENT_LEVEL_ERROR';

export const FETCH_AGENT_LEVEL_OPTIONS_REQUEST = "FETCH_AGENT_LEVEL_OPTIONS_REQUEST";
export const FETCH_AGENT_LEVEL_OPTIONS_SUCCESS = "FETCH_AGENT_LEVEL_OPTIONS_SUCCESS";
export const FETCH_AGENT_LEVEL_OPTIONS_ERROR = "FETCH_AGENT_LEVEL_OPTIONS_ERROR";

export const FETCH_AGENT_COMMISSION_REQUEST = "FETCH_AGENT_COMMISSION_REQUEST";
export const FETCH_AGENT_COMMISSION_SUCCESS = "FETCH_AGENT_COMMISSION_SUCCESS";
export const FETCH_AGENT_COMMISSION_ERROR = "FETCH_AGENT_COMMISSION_ERROR";

export const FETCH_AGENT_COMMISSION_HISTORY_REQUEST = "FETCH_AGENT_COMMISSION_HISTORY_REQUEST";
export const FETCH_AGENT_COMMISSION_HISTORY_SUCCESS = "FETCH_AGENT_COMMISSION_HISTORY_SUCCESS";
export const FETCH_AGENT_COMMISSION_HISTORY_ERROR = "FETCH_AGENT_COMMISSION_HISTORY_ERROR";

export const GET_AGENT_COMMISSION_DETAIL_REQUEST = "GET_AGENT_COMMISSION_DETAIL_REQUEST";
export const GET_AGENT_COMMISSION_DETAIL_SUCCESS = "GET_AGENT_COMMISSION_DETAIL_SUCCESS";
export const GET_AGENT_COMMISSION_DETAIL_ERROR = "GET_AGENT_COMMISSION_DETAIL_ERROR";

export const UPDATE_AGENT_COMMISSION_REQUEST = 'UPDATE_AGENT_COMMISSION_REQUEST';
export const UPDATE_AGENT_COMMISSION_SUCCESS = 'UPDATE_AGENT_COMMISSION_SUCCESS';
export const UPDATE_AGENT_COMMISSION_ERROR = 'UPDATE_AGENT_COMMISSION_ERROR';

export const GENERATE_AGENT_COMMISSION_PDF_REQUEST = 'GENERATE_AGENT_COMMISSION_PDF_REQUEST';
export const GENERATE_AGENT_COMMISSION_PDF_SUCCESS = 'GENERATE_AGENT_COMMISSION_PDF_SUCCESS';
export const GENERATE_AGENT_COMMISSION_PDF_ERROR = 'GENERATE_AGENT_COMMISSION_PDF_ERROR';

//agent group
export const fetchAgentGroups = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_AGENTS_REQUEST, FETCH_AGENTS_SUCCESS, FETCH_AGENTS_ERROR],
      callAPI: () => ApiClient.post('agent/AgentGroup/Search', data),
      payload: { data },
    }),
  );
};

export const generateAgentCommissionPdf = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GENERATE_AGENT_COMMISSION_PDF_REQUEST,
        GENERATE_AGENT_COMMISSION_PDF_SUCCESS,
        GENERATE_AGENT_COMMISSION_PDF_ERROR
      ],
      callAPI: () => ApiClient.post(`agent/AgentCommissions/CreateAgentCommissionPDF`, data),
      payload: { data },
    }),
  );
};

export const generateAgentCommissionCsv = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GENERATE_AGENT_COMMISSION_PDF_REQUEST,
        GENERATE_AGENT_COMMISSION_PDF_SUCCESS,
        GENERATE_AGENT_COMMISSION_PDF_ERROR
      ],
      callAPI: () => ApiClient.post(`agent/AgentCommissions/ExportAgentCommissionCsv`, data),
      payload: { data },
    }),
  );
};

export const generateAgentCommissionDetailPdf = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GENERATE_AGENT_COMMISSION_PDF_REQUEST,
        GENERATE_AGENT_COMMISSION_PDF_SUCCESS,
        GENERATE_AGENT_COMMISSION_PDF_ERROR
      ],
      callAPI: () => ApiClient.post(`agent/AgentCommissions/CreateAgentCommissionDetailsPDF`, data),
      payload: { data },
    }),
  );
};

export const getAgentGroupDetail = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GET_AGENT_DETAIL_REQUEST,
        GET_AGENT_DETAIL_SUCCESS,
        GET_AGENT_DETAIL_ERROR,
      ],
      callAPI: () => ApiClient.get(`agent/AgentGroup/GetDetail/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const updateAgentGroup = (id, data, formId) => dispatch => {
  console.log(id);
  console.log(data);

  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [UPDATE_AGENT_REQUEST, UPDATE_AGENT_SUCCESS, UPDATE_AGENT_ERROR],
      callAPI: () => ApiClient.put(`agent/AgentGroup/${id}`, data),
      payload: { data: { id, ...data }, formId },
    }),
  );
};

export const deleteAgentGroup = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [DELETE_AGENT_GROUP_REQUEST, DELETE_AGENT_GROUP_SUCCESS, DELETE_AGENT_GROUP_ERROR],
      callAPI: () => ApiClient.delete(`agent/AgentGroup/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const createAgentGroup = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [CREATE_AGENT_LEVEL_REQUEST, CREATE_AGENT_LEVEL_SUCCESS, CREATE_AGENT_LEVEL_ERROR],
      callAPI: () => ApiClient.post('agent/AgentGroup', data),
      payload: { data, formId },
    }),
  );
};

export const fetchAgents = data => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [FETCH_AGENTS_REQUEST, FETCH_AGENTS_SUCCESS, FETCH_AGENTS_ERROR],
      callAPI: () => ApiClient.post('agent/Agents/Search', data),
      payload: { data },
    }),
  );
};
export const fetchAgentOptions = () => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_AGENT_OPTIONS_REQUEST,
        FETCH_AGENT_OPTIONS_SUCCESS,
        FETCH_AGENT_OPTIONS_ERROR,
      ],
      callAPI: () => ApiClient.get('agent/Agents/GetSelectList'),
      payload: {},
    }),
  );
};

export const fetchAgentGroupOptions = () => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_AGENT_GROUP_OPTIONS_REQUEST,
        FETCH_AGENT_GROUP_OPTIONS_SUCCESS,
        FETCH_AGENT_GROUP_OPTIONS_ERROR,
      ],
      callAPI: () => ApiClient.get('agent/AgentGroup/GetSelectList'),
      payload: {},
    }),
  );
};

export const getAgentHierarchyData = () => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GET_AGENT_HIERARCHY_DATA_REQUEST,
        GET_AGENT_HIERARCHY_DATA_SUCCESS,
        GET_AGENT_HIERARCHY_DATA_ERROR,
      ],
      callAPI: () => ApiClient.get('agent/Agents/GetHierarchyData'),
      payload: {},
    }),
  );
};

export const getAgentDetail = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        GET_AGENT_DETAIL_REQUEST,
        GET_AGENT_DETAIL_SUCCESS,
        GET_AGENT_DETAIL_ERROR,
      ],
      callAPI: () => ApiClient.get(`agent/Agents/GetDetail/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const updateAgent = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [UPDATE_AGENT_REQUEST, UPDATE_AGENT_SUCCESS, UPDATE_AGENT_ERROR],
      callAPI: () => ApiClient.put(`agent/Agents/${id}`, data),
      payload: { data: { id, ...data }, formId },
    }),
  );
};

export const deleteAgent = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [DELETE_AGENT_REQUEST, DELETE_AGENT_SUCCESS, DELETE_AGENT_ERROR],
      callAPI: () => ApiClient.delete(`agent/Agents/${id}`),
      payload: { data: { id } },
    }),
  );
};

export const fetchAgentCommission = data => dispatch => {

  return Promise.resolve().then(() =>

    dispatch({

      types: [FETCH_AGENT_COMMISSION_REQUEST, FETCH_AGENT_COMMISSION_SUCCESS, FETCH_AGENT_COMMISSION_ERROR],
      callAPI: () => ApiClient.post('agent/AgentCommissions/Search', data),
      payload: { data },
    }),
  );

};

export const updateAgentCommission = (id, data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [UPDATE_AGENT_COMMISSION_REQUEST, UPDATE_AGENT_COMMISSION_SUCCESS, UPDATE_AGENT_COMMISSION_ERROR],
      callAPI: () => ApiClient.put(`agent/AgentCommissions/Update`, data),
      payload: { data: { id, ...data }, formId },
    }),
  );
};


export const getAgentCommissionDetail = data => dispatch => {

  return Promise.resolve().then(() =>

    dispatch({

      types: [GET_AGENT_COMMISSION_DETAIL_REQUEST,
        GET_AGENT_COMMISSION_DETAIL_SUCCESS,
        GET_AGENT_COMMISSION_DETAIL_ERROR,],
      callAPI: () => ApiClient.post('agent/AgentCommissions/AgentCommissionDetail', data),
      payload: { data },
    }),
  );

};




//Agent Level
export const fetchAgentLevel = data => dispatch => {

  return Promise.resolve().then(() =>

    dispatch({

      types: [FETCH_AGENT_LEVEL_REQUEST, FETCH_AGENT_LEVEL_SUCCESS, FETCH_AGENT_LEVEL_ERROR],
      callAPI: () => ApiClient.post('agent/AgentLevel/Search', data),
      payload: { data },
    }),
  );

};


export const fetchAgentLevelOptions = () => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [
        FETCH_AGENT_LEVEL_OPTIONS_REQUEST,
        FETCH_AGENT_LEVEL_OPTIONS_SUCCESS,
        FETCH_AGENT_LEVEL_OPTIONS_ERROR,
      ],
      callAPI: () => ApiClient.get('agent/AgentLevel/GetSelectList'),
      payload: {},
    }),
  );
};

export const createAgentLevel = (data, formId) => dispatch => {
  return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
    dispatch({
      types: [CREATE_AGENT_LEVEL_REQUEST, CREATE_AGENT_LEVEL_SUCCESS, CREATE_AGENT_LEVEL_ERROR],
      callAPI: () => ApiClient.post('agent/AgentLevel/Create', data),
      payload: { data, formId },
    }),
  );
};


export const getAgentLevelDetail = id => dispatch => {

  return Promise.resolve().then(() =>
    dispatch({
      types: [GET_AGENT_LEVEL_DETAIL_REQUEST, GET_AGENT_LEVEL_DETAIL_SUCCESS, GET_AGENT_LEVEL_DETAIL_ERROR],
      callAPI: () => ApiClient.get(`agent/AgentLevel/GetDetail/${id}`),
      payload: { data: { id } },
    }),
  );
};



export const deleteAgentLevel = id => dispatch => {
  return Promise.resolve().then(() =>
    dispatch({
      types: [DELETE_AGENT_LEVEL_REQUEST, DELETE_AGENT_LEVEL_SUCCESS, DELETE_AGENT_LEVEL_ERROR],
      callAPI: () => ApiClient.delete(`agent/AgentLevel/${id}`),
      payload: { data: { id } },
    }),
  );
};

const initialState = {
  payload: {},
  data: {},
  response: {},
  error: {},
  errorMessage: '',
  successMessage: '',
};

export default function reducer(state = initialState, action) {
  const { payload, response, error, successMessage, errorMessage } = action;
  switch (action.type) {
    case FETCH_AGENTS_REQUEST:
    case FETCH_AGENT_OPTIONS_REQUEST:
    case FETCH_AGENT_GROUP_OPTIONS_REQUEST:
    case GET_AGENT_HIERARCHY_DATA_REQUEST:
    case GET_AGENT_DETAIL_REQUEST:
    case UPDATE_AGENT_REQUEST:
    case DELETE_AGENT_REQUEST:
    case FETCH_AGENT_LEVEL_OPTIONS_REQUEST:
    case FETCH_AGENT_LEVEL_REQUEST:
    case GET_AGENT_LEVEL_DETAIL_REQUEST:
    case CREATE_AGENT_LEVEL_REQUEST:
    case DELETE_AGENT_LEVEL_REQUEST:
    case FETCH_AGENT_COMMISSION_REQUEST:
    case FETCH_AGENT_COMMISSION_HISTORY_REQUEST:
    case DELETE_AGENT_GROUP_REQUEST:
    case GET_AGENT_COMMISSION_DETAIL_REQUEST:
    case UPDATE_AGENT_COMMISSION_REQUEST:
      return {
        ...state,
        payload,
        response: {},
        error: {},
        successMessage: '',
        errorMessage: '',
      };

    case FETCH_AGENTS_SUCCESS:
    case FETCH_AGENT_COMMISSION_SUCCESS:

      return {
        ...state,
        data: {
          ...state.data,
          items: response.data.data.items,
          pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case GET_AGENT_COMMISSION_DETAIL_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          itemsone: response.data.data,

        },
        response,
        successMessage,
      };
    case FETCH_AGENT_OPTIONS_SUCCESS:
      return {
        ...state,
        data: { ...state.data, agentOptions: response.data.data },
        response,
        successMessage,
      };

    case FETCH_AGENT_GROUP_OPTIONS_SUCCESS:
      return {
        ...state,
        data: { ...state.data, agentGroupOptions: response.data.data },
        response,
        successMessage,
      };

    case GET_AGENT_DETAIL_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          item: response.data.data,
        },
        response,
        successMessage,
      };
    case GET_AGENT_HIERARCHY_DATA_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          hierarchyData: response.data.data,
        },
        response,
        successMessage,
      };

    case UPDATE_AGENT_COMMISSION_SUCCESS:
    case UPDATE_AGENT_SUCCESS:
    case DELETE_AGENT_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
        },
        response,
        successMessage,
      };

    //AGENT LEVEL


    case FETCH_AGENT_LEVEL_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          items: response.data.data.items,
          pages: response.data.data.pageCount,
        },
        response,
        successMessage,
      };

    case FETCH_AGENT_LEVEL_OPTIONS_SUCCESS:
      return {
        ...state,
        data: { ...state.data, agentLeveloptions: response.data.data },
        response,
        successMessage,
      };




    case CREATE_AGENT_LEVEL_SUCCESS:

    case DELETE_AGENT_LEVEL_SUCCESS:
      return {
        ...state,
        response,
        successMessage,
      };

    case GET_AGENT_LEVEL_DETAIL_SUCCESS:

      return {
        ...state,
        data: {
          ...state.data,
          item: response.data.data,
        },
        response,
        successMessage,
      };

    case FETCH_AGENT_LEVEL_OPTIONS_ERROR:
    case FETCH_AGENT_LEVEL_ERROR:
    case GET_AGENT_LEVEL_DETAIL_ERROR:
    case CREATE_AGENT_LEVEL_ERROR:
    case DELETE_AGENT_LEVEL_ERROR:
    //END AGENT LEVEL
    case FETCH_AGENTS_ERROR:
    case FETCH_AGENT_OPTIONS_ERROR:
    case FETCH_AGENT_GROUP_OPTIONS_ERROR:
    case GET_AGENT_HIERARCHY_DATA_ERROR:
    case GET_AGENT_DETAIL_ERROR:
    case UPDATE_AGENT_ERROR:
    case DELETE_AGENT_ERROR:
    case FETCH_AGENT_COMMISSION_ERROR:
    case FETCH_AGENT_COMMISSION_HISTORY_ERROR:
    case GET_AGENT_COMMISSION_DETAIL_ERROR:
    case DELETE_AGENT_GROUP_SUCCESS:
    case UPDATE_AGENT_COMMISSION_ERROR:
      return {
        ...state,
        payload,
        error,
        errorMessage,
      };
    default:
      return state;
  }
}
